"use client";

import { Tooltip } from "@/components/ui/tooltip";
import Cabinet1 from "@/images/product-images/cabinet-e2800/front.png";
import Cabinet4 from "@/images/product-images/cabinet-e2800/open.png";
import Cabinet2 from "@/images/product-images/cabinet-e2820/front.png";
import Cabinet3 from "@/images/product-images/cabinet-e2820/open.png";
import Cabinet5 from "@/images/product-images/cabinet-e2830/front.png";
import Cabinet6 from "@/images/product-images/cabinet-e2840/front.png";
import Image from "next/image";
import Link from "next/link";

const toolTipStyles =
  "mt-20 shadow-custom bg-primary text-accent p-8 rounded-xs w-100 flex flex-col items-center";

const nodes = [
  {
    key: "E2830",
    node: (
      <div className={toolTipStyles}>
        <h2 className="mb-3 font-serif text-2xl uppercase">Model E2830</h2>
        <p className="mb-10 font-mono">$1595</p>
        <ul className="flex gap-5">
          <li className="rounded-sm border-1 border-green-border bg-green-card p-3">
            Includes 100 trays
          </li>
          <li className="rounded-sm border-1 border-green-border bg-green-card p-3">
            Holds 2000 slides
          </li>
        </ul>
      </div>
    ),
    image: Cabinet5,
    size: "h-[25vw] w-auto xl:h-94",
    marginBottom: "-mb-1",
  },
  {
    key: "E2800",
    node: (
      <div className={toolTipStyles}>
        <h2 className="mb-3 font-serif text-2xl uppercase">Model E2800</h2>
        <p className="mb-10 font-mono">$499</p>
        <ul className="flex gap-5">
          <li className="rounded-sm border-1 border-green-border bg-green-card p-3">
            Includes 25 trays
          </li>
          <li className="rounded-sm border-1 border-green-border bg-green-card p-3">
            Holds 500 slides
          </li>
        </ul>
      </div>
    ),
    image: Cabinet1,
    size: "h-[13vw] w-auto xl:h-50",
  },
  {
    key: "E2820",
    node: (
      <div className={toolTipStyles}>
        <h2 className="mb-3 font-serif text-2xl uppercase">Model E2820</h2>
        <p className="mb-10 font-mono">$899</p>
        <ul className="flex gap-5">
          <li className="rounded-sm border-1 border-green-border bg-green-card p-3">
            Includes 50 trays
          </li>
          <li className="rounded-sm border-1 border-green-border bg-green-card p-3">
            Holds 1000 slides
          </li>
        </ul>
      </div>
    ),
    image: Cabinet2,
    size: "w-auto h-[26vw] xl:h-105",
    marginBottom: "-mb-2",
  },
  {
    key: "E2840",
    node: (
      <div className={toolTipStyles}>
        <h2 className="mb-3 font-serif text-2xl uppercase">Model E2840</h2>
        <p className="mb-10 font-mono">$1995</p>
        <ul className="flex gap-5">
          <li className="rounded-sm border-1 border-green-border bg-green-card p-3">
            Includes 150 trays
          </li>
          <li className="rounded-sm border-1 border-green-border bg-green-card p-3">
            Holds 3000 slides
          </li>
        </ul>
      </div>
    ),
    image: Cabinet6,
    size: "h-[25vw] w-auto xl:h-102",
    marginBottom: "-mb-1",
  },
];

export default function Gallery() {
  return (
    <>
      {/* DESKTOP VERSION */}
      {nodes.map(({ key, node, image, size, marginBottom }) => (
        <Tooltip
          key={key}
          content={node}
          placement="top"
          offsetValue={0}
          animationClass="transition-opacity duration-200 ease-out"
        >
          <Link href={`product/${key}-microscope-slide-cabinet`}>
            <button className="hidden md:block">
              <div className="group relative">
                <div className="transition-blur mx-2 mt-5 mb-8 duration-200 lg:mx-5">
                  <Image
                    src={image}
                    alt={`Cabinet model ${key}`}
                    className={`${size} ${marginBottom} drop-shadow-2xl`}
                  />
                </div>
                <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
                  <div className="flex h-[4vw] max-h-[60px] w-[8vw] max-w-[120px] min-w-[80px] scale-0 transform items-center justify-center rounded-sm bg-black/30 font-mono text-sm text-accent uppercase opacity-0 drop-shadow-2xl backdrop-blur-[100px] transition-all duration-400 group-hover:scale-100 group-hover:opacity-100 lg:text-lg">
                    Shop
                  </div>
                </div>
              </div>
            </button>
          </Link>
        </Tooltip>
      ))}
      {/* MOBILE VERSION */}
      <div className="grid w-full grid-cols-5 grid-rows-2 items-center bg-card md:hidden">
        <Link
          href={`product/e2800-microscope-slide-cabinet`}
          className="col-start-1 col-end-3 flex h-full flex-col items-center border-x-1 border-t-1 border-primary p-3"
        >
          <p className="mb-3 self-start font-mono text-xs">e2800</p>
          <Image
            src={Cabinet4}
            alt="e2800 cabinet"
            className="my-auto flex h-[18vw] w-auto items-center justify-center drop-shadow-xl"
          ></Image>
        </Link>
        <Link
          href={`product/e2830-microscope-slide-cabinet`}
          className="col-start-3 col-end-6 flex h-full flex-col items-center border-t-1 border-r-1 border-primary p-3"
        >
          <p className="mb-3 self-start font-mono text-xs">e2830</p>
          <Image
            src={Cabinet5}
            alt="e2830 cabinet"
            className="flex h-[32vw] w-auto items-center justify-center drop-shadow-xl"
          ></Image>
        </Link>
        <Link
          href={`product/e2840-microscope-slide-cabinet`}
          className="col-span-3 col-start-1 flex h-full flex-col items-center border-x-1 border-y-1 border-primary p-3"
        >
          <p className="mb-3 self-start font-mono text-xs">e2840</p>
          <Image
            src={Cabinet6}
            alt="e2840 cabinet"
            className="flex h-[32vw] w-auto items-center justify-center drop-shadow-xl"
          ></Image>
        </Link>
        <Link
          href={`product/e2820-microscope-slide-cabinet`}
          className="col-span-2 col-start-4 flex h-full flex-col items-center border-y-1 border-r-1 border-primary p-3"
        >
          <p className="mb-3 self-start font-mono text-xs">e2820</p>
          <Image
            src={Cabinet3}
            alt="e2820 cabinet"
            className="mb-3 h-[32vw] w-auto drop-shadow-xl"
          ></Image>
        </Link>
      </div>
    </>
  );
}
